export interface Testimonial {
  text: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    text: 'I used to spend hours planning every class from scratch. Having the lessons already structured and visual gives me a much clearer way to teach and saves me a lot of preparation time.',
    role: 'Makeup Educator',
  },
  {
    text: 'The visual technique guides make demonstrations much easier. My students can clearly see placement, blending, and corrections instead of relying only on verbal explanations.',
    role: 'Makeup Instructor',
  },
  {
    text: 'The correction and assessment tools are what I value most. I have a clearer way to guide students, correct mistakes, and track their progress.',
    role: 'Beauty Academy Instructor',
  },
]
